// ----------------------------------------------------------------------

export default function Badge() {
  return {
    MuiBadge: {
      styleOverrides: {
        badge: {
          borderRadius: 0
        },
        dot: {
          width: 10,
          height: 10,
          borderRadius: 0
        }
      }
    }
  };
}
